export const getSelectableBoxContainerStyles = () => ({
    label: {
        flexBasis: '50%',
    },
});
//# sourceMappingURL=InfoModal.styles.js.map